import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PolygonDrawComponent } from './polygon-draw.component';

import { MaterialModule } from '../material.module';

@NgModule({
  declarations: [PolygonDrawComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  exports: [PolygonDrawComponent],
})
export class PolygonDrawModule {}
